import type { GtmPlugin } from '@sports-utils/gtm';

function buildClarityEventName(eventData: Record<string, string | undefined>): string {
    const { type, page, feature, label, value } = eventData;
    return [type, page, feature, label, value].filter(Boolean).join('_');
}

function applyClarityTags(eventData: Record<string, string | undefined>): void {
    Object.entries(eventData).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
            window.clarity?.('set', key, value);
        }
    });
}

export function ClarityPlugin(enable = true): GtmPlugin {
    return (_context, gtmEvent) => {
        if (enable) {
            const eventName = buildClarityEventName(gtmEvent);
            if (eventName) {
                window.clarity?.('event', eventName);
                applyClarityTags(gtmEvent);
            }
        }
        return gtmEvent;
    };
}
